import SubscriptionForClient from "./SubscriptionForClient";
import SubscriptionForRepresentative from "./SubscriptionForRepresentative";
import Modal from "../../components/controls/Modal";

export default function SubscriptionModal({
  isOpen,
  onClose,
  selectedPriceId,
  mode = "client",
  selectedDuration = 6,
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Abonnement" size="xl">
      {mode === "representative" ? (
        <SubscriptionForRepresentative selectedPriceId={selectedPriceId} />
      ) : (
        <SubscriptionForClient
          selectedDuration={selectedDuration}
          selectedBundleKey={selectedPriceId}
          onClose={onClose}
        />
      )}
    </Modal>
  );
}
